export default __webpack_public_path__ + "static/media/home-icon.87f6026c.webp";